// src/components/Redirects/LobbyRedirect.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import PreSelectedParlaysView from "../../views/PreSelectedParlaysView/PreSelectedParlaysView";
import MobileDetect from "mobile-detect";


const LobbyRedirect = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    const isMobile = !!md.mobile();
    return isMobile ? <PreSelectedParlaysView /> : <Navigate to="/lobby/CreateYourOwn" replace />;
};

export default LobbyRedirect;
